// @flow

import { useMutation } from '@apollo/client';

const useCustomMutation = (query, options) => {
  const [mutation, mutationResults] = useMutation(query, options);
  return [mutation, mutationResults];
};

export default useCustomMutation;
